export default __webpack_public_path__ + "static/media/GiesmininkaiMuzikantai.3b98334b.svg";